import React, { useContext } from 'react';
import classNames from 'classnames';
import { UploadImSuccessfulPage } from 'router/subrouters/pages/UploadImSuccessful';
import DealRoomContext from '../../providers/DealRoom/DealRoom.context';
import { getCreateListingRoute } from 'utils';

import './UploadImSuccessfulyWrapper.styles.scss';

type UploadImSuccessfulyWrapperProps = {
  className?: string;
};

const UploadImSuccessfulyWrapper: React.FC<UploadImSuccessfulyWrapperProps> = (
  props,
) => {
  const { className } = props;

  const { dealRoom, updateDealRoom } = useContext(DealRoomContext);

  const { _id, listingIM, listingId, listing } = dealRoom || {};

  const { type } = listing || {};

  const classes = classNames('upload-im-successfuly-wrapper', className);

  return (
    <UploadImSuccessfulPage
      className={classes}
      dealRoomId={_id}
      listingIM={listingIM}
      listingUrl={getCreateListingRoute(_id, listingId, type)}
      updateListingIm={(listingIM) => updateDealRoom({ listingIM })}
    />
  );
};

export default UploadImSuccessfulyWrapper;
